<cc-box>
  <div class="container-responsive" header box translate>
    PLANS.CARD_TITLE
  </div>
  <div *ngIf="card?.brand" class="container-responsive flex" content box>
    <div class="flex-1">
      <div class="small-header" translate>PLANS.NUMBER</div>
      <div class="card-number">
        <span class="hidden-letters">•••• •••• ••••</span>
        {{ card?.last4Digits }}
      </div>
    </div>
    <div class="flex-1">
      <div class="small-header" translate>PLANS.EXPIRY_DATE</div>
      <div class="card-expiry">{{ card?.expMonth }} / {{ card?.expYear }}</div>
    </div>
    <div class="flex-1 right">
      <button
        mat-raised-button
        color="info-full"
        (click)="handleCardChange()"
      >
        {{ 'CHANGE_CARD' | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="!card?.brand" class="container-responsive flex" content box>
    <div class="flex-1 center">
      <button
        mat-raised-button
        color="info-full"
        (click)="handleCardChange()"
      >
        {{ 'ADD_CARD' | translate }}
      </button>
    </div>
  </div>
</cc-box>
